import React from 'react'
import PropTypes from 'prop-types'

function Email({ className, title }) {
  return (
    <svg viewBox="0 0 14 13" className={className} role="img">
      <title>{title}</title>
      <g>
        <path d="M13.125 0H.875C.35 0 0 .35 0 .875V2.1l7 3.937 7-3.85V.875C14 .35 13.65 0 13.125 0z" />
        <path d="M6.563 7.787L0 4.112v7.263c0 .525.35.875.875.875h12.25c.525 0 .875-.35.875-.875V4.112L7.437 7.787c-.245.123-.63.123-.875 0z" />
      </g>
    </svg>
  )
}

Email.propTypes = {
  className: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default Email
